/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Section } from '@spotahome/ui-library';
import { trans } from '@spotahome/soyuz/client';

import { LANDING_SECTIONS } from '@spotahome/ui-library/src/tenant/components/utils/seoConstants';
import withInViewEvent from '@spotahome/ui-library/src/tenant/components/withInViewEvent';
import useHorizontalDrag from '@spotahome/ui-library/src/hooks/useHorizontalDrag';

import PropertyTypeSectionCard from './PropertyTypeSectionCard';

import './PropertyTypeSection.scss';

const PROPERTY_TYPES = ['apartments', 'sharedRoom', 'studio', 'privateRoom'];

const PropertyTypeSection = () => {
  const {
    containerRef,
    handleMouseDown,
    handleMouseUp,
    handleTouchStart,
    handleTouchEnd
  } = useHorizontalDrag({
    onMoveStart: () => {},
    onMove: () => {}
  });

  return (
    <Section background="light" className="property-type-section__container">
      <div className="property-type-section">
        <div className="property-type-section__header">
          <h2 className="property-type-section__header-title">
            {trans('landingpage.label.propertyTypes')}
          </h2>
        </div>
        <ul
          className="property-type-section__carousel-list"
          onMouseDown={handleMouseDown}
          onMouseUp={handleMouseUp}
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
          ref={containerRef}
        >
          {PROPERTY_TYPES.map(type => (
            <li key={type} className="property-type-section__carousel-item">
              <PropertyTypeSectionCard type={type} isRedesign />
            </li>
          ))}
        </ul>
      </div>
    </Section>
  );
};

export default withInViewEvent(LANDING_SECTIONS.propertyType)(
  PropertyTypeSection
);
